<template>
    <div class="event-overlay" v-if="event" :title="$hisport.eventTitle(event, {}) + '\r\nID: ' + event.id">
        <div v-if="event.team_home" class="team-image home_team">
            <img :src="$hisport.absolute(event.team_home.logo, {default:'/images/team_default.png', w: 64})"  v-img-fallback="'/images/team_default.png'"/>
        </div>
        <div v-if="event.team_foreign" class="team-image foreign_team">
            <img :src="$hisport.absolute(event.team_foreign.logo, {default:'/images/team_default.png', w: 64})"  v-img-fallback="'/images/team_default.png'"/>
        </div>
        <div class="score" v-if="event.event_type == $hisport.event_types.MATCH && 
                                 event.score_team_home != undefined && event.score_team_foreign != undefined">
            <span>{{event.score_team_home}}</span>
            <span>:</span>
            <span>{{event.score_team_foreign}}</span>
        </div>

        <!-- <div class="favorite" v-if="!!event.end_timestamp">
            <img src="../../assets/images/added favourite.svg" v-if="event.favorite"/>
            <img src="../../assets/images/add favourite.svg" v-if="!event.favorite"/>
        </div> -->
        <div class="bottom-part">
          <div class="header">
            <span class="first-header-row">
              <span v-hg-event-title="{event, html:true}" class="event-title"/>
              <!--STATO IN HIPADEL-->
              <small class="hg-mini-badge" 
                      v-if="showStatus && !$hisport.options.platform.CONFIGURATION.ENABLE_EVENT_SIMPLIFIED_STATUS" 
                      v-show="videoState"
                      v-i18n="$hisport.getVideoStateName(videoState)"
                      :class="{
                        'error': [
                            $hisport.video_states.UPLOADING_ERROR,
                            $hisport.video_states.PROCESSING_ERROR
                          ].indexOf(videoState)>=0,
                        'processing': [
                            $hisport.video_states.COMPLETED,
                            $hisport.video_states.UPLOADING_ERROR,
                            $hisport.video_states.PROCESSING_ERROR
                          ].indexOf(videoState)<0,
                        'ok': [
                            $hisport.video_states.COMPLETED,
                          ].indexOf(videoState)>=0,
                      }" />
              <!--STATO IN HIGOAL-->
              <small class="hg-mini-badge error" v-else-if="showStatus && videoState == $hisport.video_states.UPLOADING_ERROR" v-i18n="'VIDEO_ERROR'"></small>
              <small class="hg-mini-badge error" v-else-if="showStatus && videoState == $hisport.video_states.PROCESSING_ERROR" v-i18n="'VIDEO_ERROR'"></small>
              <small class="hg-mini-badge future" v-else-if="showStatus && !videoState && new Date(event.start_timestamp).getTime() > Date.now()" v-i18n="'VIDEO_CALENDAR'"></small>
              <small class="hg-mini-badge processing" v-else-if="showStatus && !videoState && new Date(event.start_timestamp).getTime() < Date.now()" v-i18n="'VIDEO_NOT_READY'"></small>
              <small class="hg-mini-badge processing" v-else-if="showStatus && videoState != $hisport.video_states.COMPLETED" v-i18n="'VIDEO_NOT_READY'"></small>
              <small class="hg-mini-badge ok" v-else-if="showStatus" v-i18n="'VIDEO_READY'"></small>
            </span>
            <span class="subtitle">
                <span class="datetime" v-if="event.start_timestamp">{{event.start_timestamp | moment("ddd D MMM yyyy (HH:mm")}} &#8674; {{event.end_timestamp | moment("HH:mm)")}}</span>
                <span class="datetime" v-if="event.timestamp">{{event.timestamp | moment("ddd D MMM yyyy HH:mm")}}</span>
                <!-- <span  v-i18n="event.sub_state || event.id"/> -->
              
                <!-- <span class="duration" v-if="!!event.end_timestamp">{{duration}} <span v-i18n="'MINUTES_SHORT'"/></span>
                <span class="modified" v-if="!!event.end_timestamp && !edit"><span class="alert-icon">i</span> <span v-i18n="'NOT_MODIFIED'"></span></span> -->
            </span>
          </div>
          <span class="edit" v-if="showEdit" @click.prevent.stop="$router.push('/events/' + event.id + '/edit')">
              <font-awesome-icon :icon="['fas','edit']" :title="'EVENT_EDIT' | i18n" />
          </span>
        </div>
    </div>
</template>
<style scoped>
.event-overlay{
   width:100%;
   height:100%;
   position:absolute;
   background-image: linear-gradient(to bottom, rgba(4,21,54, 0.2), rgba(4,21,54, 0.3) 50%, rgba(4,21,54, 0.8) 100%);
   /* background:url("../../assets/images/overlay2.svg"); */
   background-size: cover;
   z-index: 2;
 }
.event-overlay .event-title{
  text-overflow:ellipsis;
  overflow:hidden;
  display: inline-block;
  max-width: calc(100% - 50px);
  white-space: nowrap;
}
.event-overlay .first-header-row .hg-mini-badge{
  position:absolute;
}
.event-overlay .team-image{
   width:30px;
   height:30px;
   position:absolute;
   top:15px;
   left:15px;
   background:var(--white);
   border-radius: var(--border-radius);
   text-align:center;
   padding:5px;
   box-sizing: border-box;
 }
 .event-overlay .team-image img{
    max-width: 100%;
    max-height:100%;
  }
 .event-overlay .team-image.foreign_team{
    left:50px;
  }
.event-overlay .score{
    width:48px;
    height:30px;
    position:absolute;
    top:15px;
    right:15px;
    border-radius: var(--border-radius);
    text-align:center;
    padding:5px;
    box-sizing: border-box;
    background: rgba(0,14,41,0.6) 0% 0% no-repeat padding-box;
    border-radius: 7px;
    font-weight:bold;
    font-size:18px;
 }
.event-overlay .favorite{
    position:absolute;
    bottom:10px;
    right:15px;
    text-align:center;
    box-sizing: border-box;
 }
.event-overlay .header{
  width:100%;
    border-radius: var(--border-radius);
    text-align:center;
    padding:5px;
    box-sizing: border-box;
    font-weight:bold;
    font-size:13px;
    display:flex;
    flex-direction: column;
    text-align:left;
    flex: 1 1 2;
 }


.event-overlay .header .subtitle{
  margin-top:5px;
  font-size:10px;
  font-weight:normal;
}.event-overlay .header .subtitle .datetime{
  font-weight:bold;
  text-transform: capitalize;
}
.event-overlay .header .subtitle>* + *:before{
  content: "•";
  width:10px;
  display:inline-block;
  text-align: center;
}

.event-overlay .bottom-part{
  position:absolute;
  bottom:15px;
  left:15px;
  display:flex;
  flex-direction: row;
  width:calc(100% - 30px);
  height:45px;
}
.event-overlay .edit{
  flex: 0 0 0;
  width:50px;
  height:50px;
  margin-top:20px;
  padding:8px;
}
.event-overlay .edit:hover{
  background:var(--hg-red);
}

.event-overlay .header .hg-mini-badge{
  display:inline-block;
  color:#FFFFFF;
  background:var(--grey);
  margin-left:5px;
  padding:3px;
  border-radius:3px;
}
.event-overlay .header .hg-mini-badge.ok{
  background:var(--hg-info);
}
.event-overlay .header .hg-mini-badge.future{
  background:var(--violet);
}
.event-overlay .header .hg-mini-badge.error{
  background:var(--hg-red);
}
.event-overlay .header .hg-mini-badge.ko{
  background:var(--hg-warn);
}
</style>
<script>
export default {
    props: {
        event: {type: Object, default: function(){ return null }},
        showStatus: {type: Boolean, default: false},
        showEdit: {type: Boolean, default: false}
    },
    computed: {
      videoState: function(){
        return this.event && this.event.video && this.event.video.state;
      }
    }
}
</script>